import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { OrderServiceService } from 'src/app/admin/services/orders/order-service.service';
import { UserdataService } from 'src/app/admin/services/shared/userdata/userdata.service';

@Component({
    selector: 'app-customer-call-order',
    templateUrl: './customer-call-order.component.html',
    styleUrls: ['./customer-call-order.component.scss'],
    standalone: false
})
export class CustomerCallOrderComponent implements OnInit {

  constructor(
    private order: OrderServiceService,
    private spinner: NgxSpinnerService,
    private userdata: UserdataService,
    private router: ActivatedRoute
  ) { } 
  title = 'angular-datatables';

  callList = [];  
  id: any = '';
  temp: any = [];
  getReportData: any = [];
  ColumnMode = ColumnMode;
  token: any = [];

  @ViewChild(DatatableComponent) myFilterTable: DatatableComponent | any;

  ngOnInit() {
    //this.id = this.router.snapshot.paramMap.get('id')
    this.router.parent?.params.subscribe(
      (params) => {
        this.id = params.data
      });
    this.getCallOrderList()
    this.callList = this.getReportData;
  }

  /* ***********
  list All Call Orders
  *********** */

  getCallOrderList() {
    this.spinner.show()
    this.order.getCallOrderList({'userId':this.userdata.getId(),customerId:this.id}).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.callList = res.data;
        //console.log(this.callList)
        this.temp = this.callList
        this.getReportData =this.callList
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
      }
    );
  }

  /**
 * Update filter
 */
updateFilter(event: any) {
  //console.log(this.temp)
  const val = event.target.value.toLowerCase();

  const temp = this.temp.filter(function (d: any) {
    return d.customerId?.name.toLowerCase().indexOf(val) !== -1 ||
        d.ocallId.toString().indexOf(val) !== -1 ||
        d.astroId?.name.toLowerCase().indexOf(val) !== -1 || !val
  });

  // update the rows
  this.callList = temp;
  // Whenever the filter changes, always go back to the first page
  this.myFilterTable.offset = 0;
}
  /**
   * Not Answered Reports
   */
  notAnswered(){
    this.spinner.show()
    this.order.getCallOrderList({'userId':this.userdata.getId(),'is_astro_answer':false,customerId:this.id}).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.callList = res.data;
        //console.log(this.callList)
        this.temp = this.callList;
        this.getReportData = this.callList;
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
      }
    );
  }

  /**
   * Not Reviewed Reports
   */
  notReviewed(){
    this.spinner.show()
    this.order.getCallOrderList({'userId':this.userdata.getId(),'is_order_reviewed':false,customerId:this.id}).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.callList = res.data;
        //console.log(this.callList)
        this.temp = this.callList;
        this.getReportData = this.callList;
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
      }
    );
  }

  /**
   * No Customer feedback Reports
   */
  noCustomerFeedback(){
    this.spinner.show()
    this.order.getCallOrderList({'userId':this.userdata.getId(),'is_feedback_given':false,customerId:this.id}).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.callList = res.data;
        //console.log(this.callList)
        this.temp = this.callList;
        this.getReportData = this.callList;
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
      }
    );
  }

  /**
   * No Astrologer feedback reply Reports
   */
  noAstrologerFeedbackReply(){
    this.spinner.show()
    this.order.getCallOrderList({'userId':this.userdata.getId(),'is_astro_replied_feedback':false,customerId:this.id}).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.callList = res.data;
        //console.log(this.callList)
        this.temp = this.callList;
        this.getReportData = this.callList;
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
      }
    );
  }
}
